module.exports = __webpack_public_path__ + "img/gme-ftd-percent-trade-volume.360225d2.jpg";